import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';

import { Button } from '@styled';
import useStripeInstances from '@hooks/useStripeInstances';

const CheckoutFormBody = ({ onCheckoutClick, onLoadingChange, onErrorChange }) => {
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async event => {
        event.preventDefault();

        const cardElement = elements.getElement(CardElement);

        // If card value is invalid or empty, make a submission just to get the error message
        // if (cardElement._invalid) {
        //     console.log(`cardElement is invalid`);
        //     onErrorChange('Your card number is invalid.');
        //     return;
        // }

        if (cardElement._empty) {
            onErrorChange('Your card number is incomplete.');
            return;
        }

        // Begin requests
        onLoadingChange(true);
        onErrorChange(null);
        onCheckoutClick(stripe, cardElement);
    };

    return (
        <>
            <CardElement />

            <Button id="checkOut" type="submit" disabled={!stripe} onClick={handleSubmit}>
                CHECKOUT
            </Button>
        </>
    );
};

CheckoutFormBody.propTypes = {
    onCheckoutClick: PropTypes.func.isRequired,
    onLoadingChange: PropTypes.func.isRequired,
    onErrorChange: PropTypes.func.isRequired,
};

const CheckoutForm = ({ fund, firstName, lastName, onLoadingChange, onErrorChange, onCheckoutClick }) => {
    const { stripePromises } = useStripeInstances();
    const [stripeInstance, setStripeInstance] = useState(fund ? stripePromises[fund.locale] : stripePromises.US_FND);

    useEffect(() => {
        setStripeInstance(stripePromises[fund.locale]);
    }, [fund, stripePromises]);

    return (
        <Elements stripe={stripeInstance}>
            <CheckoutFormBody
                fund={fund}
                firstName={firstName}
                lastName={lastName}
                onCheckoutClick={onCheckoutClick}
                onLoadingChange={onLoadingChange}
                onErrorChange={onErrorChange}
            />
        </Elements>
    );
};

CheckoutForm.propTypes = {
    fund: PropTypes.object.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    onCheckoutClick: PropTypes.func.isRequired,
    onLoadingChange: PropTypes.func.isRequired,
    onErrorChange: PropTypes.func.isRequired,
};

export default CheckoutForm;
